import { DispatchItemToExport } from "../../../../../core";

export const formatSkuInCustomerDispatch = {
  exportFile: "despachosPorSku.xlsx",
  columns: [
    {
      title: "Fecha original de entrega",
      name: "originalDeliveryDate",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) =>
        element.originalDeliveryDate
          ? element.originalDeliveryDate
          : element.deliveryDate,
    },
    {
      title: "Fecha de entrega",
      name: "deliveryDate",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.deliveryDate,
    },
    {
      title: "Fecha de venta",
      name: "saleDate",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.saleDate,
    },
    {
      title: "Fecha de pago",
      name: "paymentDate",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.paymentDate,
    },
    {
      title: "N° de NV",
      name: "saleNoteId",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.saleNoteId,
    },
    {
      title: "N° de despacho",
      name: "dispatchId",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.dispatchId,
    },
    {
      title: "VTEX",
      name: "vtexCode",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.vtexCode,
    },
    {
      title: "SKU",
      name: "skuCode",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.skuCode,
    },
    {
      title: "Descripción",
      name: "skuName",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.skuName,
    },
    {
      title: "LPN",
      name: "lpn",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.lpn,
    },
    {
      title: "Cantidad total",
      name: "totalAmount",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) =>
        element.totalAmount != null ? element.totalAmount : 0,
    },
    {
      title: "Cantidad a despachar",
      name: "processedAmount",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.processedAmount,
    },
    {
      title: "Cantidad entregada",
      name: "dispatchedAmount",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: () => 0,
    },
    {
      title: "Cantidad cancelada",
      name: "canceledAmount",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) =>
        element.canceledAmount != null ? element.canceledAmount : 0,
    },
    {
      title: "Ubicación de Picking",
      name: "location",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.location,
    },
    {
      title: "Modalidad de despacho",
      name: "deliveryTypeName",
      type: "string",
      editable: false,
      checkAll: false,
      align: "left",
      class: "confirmationDispatches",
      value: (element: DispatchItemToExport) => element.deliveryTypeName,
    },
    {
      title: "Tipo de despacho",
      name: "dispatchTypeName",
      type: "string",
      editable: false,
      checkAll: false,
      align: "left",
      class: "confirmationDispatches",
      value: (element: DispatchItemToExport) => element.dispatchTypeName,
    },
    {
      title: "Estado",
      name: "state",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.state,
    },
    {
      title: "Entidad Actual",
      name: "currentEntityName",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.currentEntityName,
    },
    {
      title: "Entidad de Venta",
      name: "saleLocationName",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.saleLocationName,
    },
    {
      title: "Entidad destino",
      name: "nextEntityName",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.nextEntityName,
    },
    {
      title: "Dirección de Entrega",
      name: "deliveryAddress",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) =>
        element.nextEntityName
          ? element.nextEntityAddress ? element.nextEntityAddress : element.deliveryAddress
          : element.deliveryAddress
          ? element.deliveryAddress.split("$%$").join(" ")
          : "",
    },
    {
      title: "Distrito",
      name: "dispatchDistrict",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.dispatchDistrict,
    },
    {
      title: "Zona de despacho",
      name: "dispatchZone",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.dispatchZone,
    },
    {
      title: "Referencia",
      name: "reference",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchItemToExport) => element.reference,
    },
    {
      title: "Documento de Cliente",
      name: "customerDocumentNumber",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.customerDocumentNumber,
    },
    {
      title: "Nombre de Cliente",
      name: "customer",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.customer,
    },
    {
      title: "Email del Cliente",
      name: "mailCustomer",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.mailCustomer,
    },
    {
      title: "Teléfono de Cliente",
      name: "telephone",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.telephone,
    },
    {
      title: "Documento persona que retira",
      name: "telephone",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.withdrawPersonDoc,
    },
    {
      title: "Persona que retira",
      name: "telephone",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.withdrawPerson,
    },
    {
      title: "Inicio ventana horaria",
      name: "startDateDeliveryWindow",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.startDateDeliveryWindow,
    },
    {
      title: "Fin ventana horaria",
      name: "endDateDeliveryWindow",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.endDateDeliveryWindow,
    },
    {
      title: 'Latitud',
      name: 'latitud',
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.geoLocalization != null ? element.geoLocalization.split(",")[0] : ''
    },
    {
      title: 'Longitud',
      name: 'longitud',
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.geoLocalization != null ? element.geoLocalization.split(",")[1] : ''
    },
    {
      title: 'Linea',
      name: 'linea',
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.productLine
    },
    {
      title: 'Entidad final',
      name: 'finalEntityCode',
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchItemToExport) => element.finalEntityCode
    },
  ],
};
